import SpecsForm from '@Forms/SpecsForm';

class SpecsSection extends React.Component {

    static modelToState(props) {

        var currentPage = parseInt(props.model.SpecPage, 0);

        return {
            oMMMCategoryGroupSpecs: props.model.oMMMCategoryGroupSpecs,
            oMMMCategoryGroupSpecPage: props.model.oMMMCategoryGroupSpecs[currentPage],
            oMMMDefaultSpecList: props.model.oMMMDefaultSpecList,
            oMMMMeasurementUnit: props.model.oMMMMeasurementUnit,
            oMMMCategorySpec: props.model.oMMMCategorySpec,
            oDynamicAutoComplete: props.model.oDynamicAutoComplete,
            oDynamicDropDown: props.model.oDynamicDropDown,
            DependentAutoComplete: props.model.DependentAutoComplete,
            DependentDropDowns: props.model.DependentDropDowns,
            DependentBundledSpecs: props.model.DependentBundledSpecs,
            FormInputs: props.model.FormInputs,
            ShowModal: props.model.ShowModal,
            oSpecsModal: props.model.oSpecsModal,
            SerialVIN: props.model.SerialVIN,
            ShowFE: props.model.ShowFE,
            Category: props.model.Category,
            Manufacturer: props.model.Manufacturer,
            Model: props.model.Model,
            Year: props.model.Year,
            SystemOfMeasurement: props.model.SystemOfMeasurement,
            ObjectXMLInputs: props.model.ObjectXMLInputs,
            ValidFECategory: props.model.ValidFECategory,
            SpecGroupLastSeen: props.model.SpecGroupLastSeen,
            MoreSpecsClicks: props.model.MoreSpecsClicks,
            DoneWithSpecsClicks: props.model.DoneWithSpecsClicks,
            GroupIndex: props.model.GroupIndex,
            SpecIndex: props.model.SpecIndex,
            CurrentPage: currentPage,
            QueryString: props.model.QueryString,
            NextPageURL: props.model.NextPageURL,
            Translations: props.model.Translations,
            Progress: props.model.Progress,
            PageNames: props.model.PageNames,
            ClassNamesForProgressBar: props.model.ClassNamesForProgressBar,
            IndexGeneralNotShownInSpecSection: props.model.IndexGeneralNotShownInSpecSection,
            HighlightErrors: {},
            FormErrors: [],
            InputErrors: {},
            ShowUnitSwitchModal: props.model.ShowUnitSwitchModal,
            firstSpecWithUnit: null,
            modalObject: null,
            CurrentSite: props.model.CurrentSite,
            SimplifiedSite: false
        };
    }

    constructor(props) {
        super(props);

        this.state = SpecsSection.modelToState(props);

        this.ConfirmButton = this.ConfirmButton.bind(this);
        this.SkipButton = this.SkipButton.bind(this);
        this.ValidateAndSaveSpecs = this.ValidateAndSaveSpecs.bind(this);
        this.ValidateSpec = this.ValidateSpec.bind(this);
        this.SaveSpecsToXML = this.SaveSpecsToXML.bind(this);
        this.handleFormUpdate = this.handleFormUpdate.bind(this);
        this.handleMasterViewUpdate = this.handleMasterViewUpdate.bind(this);

        //updates the parent's validator to use this method 
        var masterViewState = this.props.masterViewModel;
        masterViewState.ValidateAndSaveSpecs = this.ValidateAndSaveSpecs;
        masterViewState.ValidateSpec = this.ValidateSpec;
        masterViewState.SaveSpecsToXML = this.SaveSpecsToXML;
        this.state.IsInTranslationEditorMode = this.props.masterViewModel.IsInTranslationEditorMode;
        this.props.handleFormUpdate(masterViewState);
    }

    componentWillReceiveProps(props) {
        var currentPage = 0;
        currentPage = parseInt(props.model.SpecPage, 0);

        this.setState({
            oMMMCategoryGroupSpecs: props.model.oMMMCategoryGroupSpecs,
            oMMMCategoryGroupSpecPage: props.model.oMMMCategoryGroupSpecs[currentPage],
            oMMMDefaultSpecList: props.model.oMMMDefaultSpecList,
            oMMMMeasurementUnit: props.model.oMMMMeasurementUnit,
            oMMMCategorySpec: props.model.oMMMCategorySpec,
            oDynamicAutoComplete: props.model.oDynamicAutoComplete,
            oDynamicDropDown: props.model.oDynamicDropDown,
            DependentAutoComplete: props.model.DependentAutoComplete,
            DependentDropDowns: props.model.DependentDropDowns,
            DependentBundledSpecs: props.model.DependentBundledSpecs,
            FormInputs: props.model.FormInputs,
            ShowModal: props.model.ShowModal,
            oSpecsModal: props.model.oSpecsModal,
            SerialVIN: props.model.SerialVIN,
            ShowFE: props.model.ShowFE,
            Category: props.model.Category,
            Manufacturer: props.model.Manufacturer,
            Model: props.model.Model,
            Year: props.model.Year,
            ObjectXMLInputs: props.model.ObjectXMLInputs,
            ValidFECategory: props.model.ValidFECategory,
            SpecGroupLastSeen: props.model.SpecGroupLastSeen,
            MoreSpecsClicks: props.model.MoreSpecsClicks,
            DoneWithSpecsClicks: props.model.DoneWithSpecsClicks,
            GroupIndex: props.model.GroupIndex,
            SpecIndex: props.model.SpecIndex,
            IndexGeneralNotShownInSpecSection: props.model.IndexGeneralNotShownInSpecSection,
            CurrentPage: currentPage,
            NextPageURL: props.model.NextPageURL,
            Translations: props.model.Translations,
            Progress: props.model.Progress,
            PageNames: props.model.PageNames,
            ShowUnitSwitchModal: props.model.ShowUnitSwitchModal || this.state.ShowUnitSwitchModal,
            firstSpecWithUnit: props.model.firstSpecWithUnit || this.state.firstSpecWithUnit,
            modalObject: props.model.modalObject || this.state.modalObject,
            SimplifiedSite: false
        });

        if (props.model.HighlightErrors != null) {
            this.setState({
                HighlightErrors: props.model.HighlightErrors,
                FormErrors: props.model.FormErrors,
                InputErrors: props.model.InputErrors
            });
        }
    }

    handleFormUpdate(Model) {
        this.setState({
            oMMMCategoryGroupSpecs: Model.oMMMCategoryGroupSpecs,
            oMMMCategoryGroupSpecPage: Model.oMMMCategoryGroupSpecPage,
            oMMMDefaultSpecList: Model.oMMMDefaultSpecList,
            oMMMMeasurementUnit: Model.oMMMMeasurementUnit,
            oMMMCategorySpec: Model.oMMMCategorySpec,
            oDynamicAutoComplete: Model.oDynamicAutoComplete,
            oDynamicDropDown: Model.oDynamicDropDown,
            DependentAutoComplete: Model.DependentAutoComplete,
            FormInputs: Model.FormInputs,
            ShowModal: Model.ShowModal,
            oSpecsModal: Model.oSpecsModal,
            SerialVIN: Model.SerialVIN,
            ShowFE: Model.ShowFE,
            Category: Model.Category,
            Manufacturer: Model.Manufacturer,
            Model: Model.Model,
            Year: Model.Year,
            SystemOfMeasurement: Model.SystemOfMeasurement,
            ObjectXMLInputs: Model.ObjectXMLInputs,
            ValidFECategory: Model.ValidFECategory,
            SpecGroupLastSeen: Model.SpecGroupLastSeen,
            MoreSpecsClicks: Model.MoreSpecsClicks,
            DoneWithSpecsClicks: Model.DoneWithSpecsClicks,
            CurrentPage: Model.CurrentPage,
            QueryString: Model.QueryString,
            Translations: Model.Translations,
            NextPageURL: Model.NextPageURL,
            Progress: Model.Progress,
            PageNames: Model.PageNames,
            ClassNamesForProgressBar: Model.ClassNamesForProgressBar,
            HighlightErrors: Model.HighlightErrors,
            FormErrors: Model.FormErrors,
            InputErrors: Model.InputErrors,
            ShowUnitSwitchModal: Model.ShowUnitSwitchModal,
            firstSpecWithUnit: Model.firstSpecWithUnit,
            modalObject: Model.modalObject
        });
    }

    //Updates ViewModels in the Master View, then the MasterView will pass it down to the other child react components
    handleMasterViewUpdate(Model) {
        var masterViewModel = this.props.masterViewModel;
        masterViewModel.SpecsViewModel = Model;
        this.props.handleFormUpdate(masterViewModel);
    }

    ConfirmButton() {
        this.SaveSpecsToXML(this.state);
    }

    SkipButton() {
        var state = this.state;
        for (var i = 0; i < state.oSpecsModal.length; i++) {
            state.FormInputs[state.oSpecsModal[i].Label].Value = "";
        }
        this.SaveSpecsToXML(state);
    }

    ValidateAndSaveSpecs(bSaveXML, state, skipRequired) {
        state = state || this.state;
        //this.SaveSpecsToXML(state);

        var highlightErrors = {};
        var formErrors = state.FormErrors;
        var inputErrors = {};
        var bFirstError = true;
        var bFirstSpecErrorIsRequiredSpec = false;
        var firstSpecErrorID = "#";

        var specsToSend = [];
        var formInputs = {};
        //go through each group of specs
        for (var j = 0; j < this.state.oMMMCategoryGroupSpecs.length; j++) {
            var oMMMCategoryGroupSpecPage = this.state.oMMMCategoryGroupSpecs[j];
            //go through each spec in the group
            for (var i = 0; i < oMMMCategoryGroupSpecPage.Specs.length; i++) {
                var spec = oMMMCategoryGroupSpecPage.Specs[i];
                
                //if this spec has a value, and the spec isn't TotalWeight
                if (this.state.FormInputs[spec.SpecField] != null && this.state.FormInputs[spec.SpecField].Value != "" && spec.SpecField != "TotalWeight") {
                    specsToSend.push({
                        CategoryID: spec.CategoryID,
                        DefinedSpecID: spec.DefinedSpecID,
                        SpecField: spec.SpecField,
                        DatabaseUnit: spec.DatabaseUnit,
                        Required: spec.Required,
                        SpecInputControlType: spec.SpecInputControlType
                    });
                    formInputs[spec.SpecField] = state.FormInputs[spec.SpecField];
                    delete formInputs[spec.SpecField].Page;
                    //if this spec also has an inch field tied to it, add in that form input value
                    if (state.FormInputs[spec.SpecField + "inch#"] != null && state.FormInputs[spec.SpecField + "inch#"].Value != "") {
                        formInputs[spec.SpecField + "inch#"] = state.FormInputs[spec.SpecField + "inch#"];
                        delete formInputs[spec.SpecField + "inch#"].Page;
                    }
                    else if (state.FormInputs[spec.SpecField + "unit#"] != null && state.FormInputs[spec.SpecField + "unit#"].Value != "") {
                        formInputs[spec.SpecField + "unit#"] = state.FormInputs[spec.SpecField + "unit#"];
                        delete formInputs[spec.SpecField + "unit#"].Page;
                    }
                }
            }
        }

        var objectToSend = {
            oMMMCategorySpec: specsToSend,
            FormInputs: formInputs,
        };

        var xhr3 = new XMLHttpRequest();
        xhr3.onload = function () {
            var response = JSON.parse(xhr3.response);
            var validatedSpecs = response.oMMMCategorySpecs;
            //go through each spec we sent in
            for (var i = 0; i < validatedSpecs.length; i++) {
                var spec = validatedSpecs[i];
                //if the spec has a corresponding inch field, add in the inch value again
                if (state.FormInputs[spec.SpecField] != null && state.FormInputs[spec.SpecField].Value == "" &&
                    state.FormInputs[spec.SpecField + "inch#"] != null && state.FormInputs[spec.SpecField + "inch#"].Value != "" &&
                    state.FormInputs[spec.SpecField + "unit#"] != null && state.FormInputs[spec.SpecField + "unit#"].Value == "foot") {
                    state.FormInputs[spec.SpecField].Value = state.FormInputs[spec.SpecField + "inch#"].Value;
                    state.FormInputs[spec.SpecField + "unit#"].Value = "inch";
                    state.FormInputs[spec.SpecField + "inch#"].Value = "";
                }
                //if the value is only a vertical bar,remove it
                if (state.FormInputs[spec.SpecField] != null && state.FormInputs[spec.SpecField].Value == "|")
                    state.FormInputs[spec.SpecField].Value = ""

                
                //if we don't want to skip the required specs, OR we want to skip the required and this spec group is NOT the Required group
                if (!skipRequired || (skipRequired && !this.state.Translations["PrioritySpecs"].includes(oMMMCategoryGroupSpecPage.GroupName))) {
                    if (spec.Success == false) {
                        inputErrors[spec.SpecField] = spec.Message;
                        highlightErrors[spec.SpecField] = true;
                        if (bFirstError) {
                            bFirstError = false;
                            firstSpecErrorID = firstSpecErrorID + spec.SpecField;
                            if (spec.Required)
                                bFirstSpecErrorIsRequiredSpec = true;
                        }
                        //if we were successful but have an "Example" (corrected) value, use it
                    }
                    else if (spec.Example) {
                        state.FormInputs[spec.SpecField].Value = spec.Example;
                    }
                }
            }
            if (bFirstError) {
                formErrors = [];
                state.FormErrors = formErrors;
                this.handleMasterViewUpdate(state);
            }
        }.bind(this);

        xhr3.open("POST", '/listinginput/specs/ValidatePageSpecs' + state.QueryString, false);
        xhr3.setRequestHeader("Content-type", "application/json; charset=utf-8");
        xhr3.send(JSON.stringify(objectToSend));

        //if we have no errors, continue w/ saving the spec XML
        if (Object.keys(inputErrors).length == 0 && Object.keys(formErrors).length == 0) {
            state.HighlightErrors = highlightErrors;
            state.InputErrors = inputErrors;

            this.handleMasterViewUpdate(state);

            if (bSaveXML) {
                this.SaveSpecsToXML(state);
            }

            //return has no errors
            return false;
        }
        else {
            //override the first spec error ID since average weight and weight stop are below other specs
            if (highlightErrors["AverageWeight"]) {
                firstSpecErrorID = "#AverageWeight";
            }
            else if (highlightErrors["WeightStop"]) {
                firstSpecErrorID = "#WeightStop";
            }
            //if the spec error isn't on average weight or weight stop
            if (firstSpecErrorID != "#AverageWeight" && firstSpecErrorID != "#WeightStop") {
                //expand the header of the spec group
                //scroll to first error

                if (!bFirstSpecErrorIsRequiredSpec) {    //required specs do not have sections
                    //get the ID of the section the error belongs to. If it's closed, open it and show the error
                    firstSpecErrorID = firstSpecErrorID + "column";
                    var contentSection = $(firstSpecErrorID).parent().parent(); //"addtlSpecs-content-1"

                    var id = contentSection.attr("id").substring(contentSection.attr("id").length - 1);

                    if (contentSection.is(':hidden') && !$("#accordion-content-2").is(':hidden')) {
                        ToggleSpecsSection(id);
                    }
                }

                ScrollToElement($(firstSpecErrorID));
            }
            else {
                ScrollToElement($(firstSpecErrorID));
            }

            state.HighlightErrors = highlightErrors;
            state.InputErrors = inputErrors;
            state.FormErrors = formErrors;

            this.handleMasterViewUpdate(state);

            //return has errors
            return true;
        }
    }

    ValidateSpec(spec, state, validateSpecCallback) {

        var validationObject = {
            highlightErrors: {},
            formErrors: [],
            inputErrors: {},
            firstSpecError: "#",
            correctSpecValue: null
        };

        if (state.FormInputs[spec.SpecField] != null && state.FormInputs[spec.SpecField].Value == "" &&
            state.FormInputs[spec.SpecField + "inch#"] != null && state.FormInputs[spec.SpecField + "inch#"].Value != "" &&
            state.FormInputs[spec.SpecField + "unit#"] != null && state.FormInputs[spec.SpecField + "unit#"].Value == "foot") {
            state.FormInputs[spec.SpecField].Value = state.FormInputs[spec.SpecField + "inch#"].Value;
            state.FormInputs[spec.SpecField + "unit#"].Value = "inch";
            state.FormInputs[spec.SpecField + "inch#"].Value = "";
        }

        if (state.FormInputs[spec.SpecField] != null && state.FormInputs[spec.SpecField].Value == "|")
            state.FormInputs[spec.SpecField].Value = ""

        if (spec.Required && (state.FormInputs[spec.SpecField] == null || state.FormInputs[spec.SpecField].Value == "")) {
            var message = state.Translations["IsRequired"].replace("{0}", spec.Label);
            validationObject.highlightErrors[spec.SpecField] = true;
            validationObject.inputErrors[spec.SpecField] = message;
        }

        if (state.FormInputs[spec.SpecField] != null && state.FormInputs[spec.SpecField].Value != "") {
            var objState = {
                FormInputs: {},
            };

            objState.FormInputs[spec.SpecField] = state.FormInputs[spec.SpecField];
            if (state.FormInputs[spec.SpecField + "inch#"] != null && state.FormInputs[spec.SpecField + "inch#"].Value != "") {
                objState.FormInputs[spec.SpecField + "inch#"] = state.FormInputs[spec.SpecField + "inch#"];
            }
            else if (state.FormInputs[spec.SpecField + "unit#"] != null && state.FormInputs[spec.SpecField + "unit#"].Value != "") {
                objState.FormInputs[spec.SpecField + "unit#"] = state.FormInputs[spec.SpecField + "unit#"];
            }

            var objSpec = {
                CategoryID: spec.CategoryID,
                DefinedSpecID: spec.DefinedSpecID,
                DatabaseUnit: spec.DatabaseUnit,
                SpecInputControlType: spec.SpecInputControlType,
                SpecField: spec.SpecField,
                Dependencies: spec.Dependencies,
            };

            if (spec.Dependencies != null && spec.Dependencies.length > 0) {
                objState.oMMMCategorySpec = [];
                for (var i = 0; i < state.oMMMCategorySpec.length; i++) {
                    objState.oMMMCategorySpec.push({
                        CategoryID: state.oMMMCategorySpec[i].CategoryID,
                        DefinedSpecID: state.oMMMCategorySpec[i].DefinedSpecID,
                        DatabaseUnit: state.oMMMCategorySpec[i].DatabaseUnit,
                        SpecInputControlType: state.oMMMCategorySpec[i].SpecInputControlType,
                        SpecField: state.oMMMCategorySpec[i].SpecField,
                    });
                    objState.FormInputs[state.oMMMCategorySpec[i].SpecField] = state.FormInputs[state.oMMMCategorySpec[i].SpecField];
                }
            }

            var objectToSend = {
                oMMMCategorySpec: objSpec,
                oSpecsViewModel: objState,
            };

            var xhr3 = new XMLHttpRequest();
            xhr3.onload = function () {
                var response = JSON.parse(xhr3.response);
                if (response.oMMMCategorySpec.Success == false) {
                    if (response.oMMMCategorySpec.Example) {
                        validationObject.correctSpecValue = response.oMMMCategorySpec.Example;
                    }
                    else {
                        validationObject.highlightErrors[spec.SpecField] = true;
                        validationObject.inputErrors[spec.SpecField] = response.oMMMCategorySpec.Message;
                    }
                }

                if (validateSpecCallback) {
                    validateSpecCallback(validationObject);
                }
            }.bind(this);
            xhr3.open("POST", '/listinginput/specs/ValidateSpec' + state.QueryString, true);
            xhr3.setRequestHeader("Content-type", "application/json");
            xhr3.send(JSON.stringify(objectToSend));
        }
        else if (!spec.Required && state.FormInputs[spec.SpecField].Value == "") {
            delete validationObject.highlightErrors[spec.SpecField];
            delete validationObject.inputErrors[spec.SpecField];
        }

        return validationObject;
    }

    SaveSpecsToXML(state) {
        //ajax call to save specs since there's no errors
        //var objectToSend = {
        //    SpecPage: state.CurrentPage,
        //    SerialVIN: state.SerialVIN,
        //    Manufacturer: state.Manufacturer,
        //    Model: state.Model,
        //    Year: state.Year,
        //    Category: state.Category,
        //    FormInputs: state.FormInputs,
        //    SystemOfMeasurement: state.SystemOfMeasurement,
        //    ShowUnitSwitchModal: state.ShowUnitSwitchModal,
        //};

        //var xhr1 = new XMLHttpRequest();
        //xhr1.open("POST", '/listinginput/specs/save' + state.QueryString, true);
        //xhr1.setRequestHeader("Content-type", "application/json");
        //xhr1.send(JSON.stringify(objectToSend));
    }

    render() {
        if (this.state.CurrentSite == "RVUniverse") {
            this.state.SimplifiedSite = true;
        }
        return (
            <div>
                <SpecsForm
                    model={this.state}
                    handleFormUpdate={(e) => { this.handleFormUpdate(e); }}
                    handleMasterViewUpdate={(e) => { this.handleMasterViewUpdate(e); }}
                    ValidateSpec={this.ValidateSpec}
                    ValidateAndSaveSpecs={this.ValidateAndSaveSpecs}
                    SaveSpecsToXML={this.SaveSpecsToXML}
                />
            </div>
        );
    }
}

export default SpecsSection;
global.SpecsSection = SpecsSection;